import React from "react";
import {
  AlertComponent,
  LoginClientComponent,
  ShowContent,
} from "../../components";
import { useContext } from "react";
import AuthContext from "../../context/AuthContext";
import { Box, Container, Fade } from "@mui/material";

export const LoginClient = () => {
  const { onLogin, isLoading, isSuccess, isError } = useContext(AuthContext);

  let content: JSX.Element | JSX.Element[];
  content = (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 30% 50%, rgba(251, 171, 53, 0.08) 0%, transparent 50%), radial-gradient(circle at 70% 50%, rgba(90, 100, 119, 0.05) 0%, transparent 50%)",
          pointerEvents: "none",
        },
      }}
    >
      <Container maxWidth="sm">
        <Fade in timeout={1000}>
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <LoginClientComponent onClickLogin={onLogin} />

            {isSuccess && <AlertComponent type="success" />}
            {isError && (
              <AlertComponent
                type="error"
                message={"Not Authorized, please contact the Administrator"}
              />
            )}
          </Box>
        </Fade>
      </Container>
    </Box>
  );

  return <ShowContent error={""} isLoading={isLoading} content={content} />;
};
